import axios from "@/axios-service";
import { AxiosRequestConfig } from "axios";
import { GeoJSONFeatureCollection } from "ol/format/GeoJSON";

const MS_URL = "senana/api/shape-converter/shapes";

export const sendGeoFile = async (mapFile: File): Promise<GeoJSONFeatureCollection> => {
  const formData = new FormData();

  formData.append("file", mapFile);

  const requestConfig = {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  } as AxiosRequestConfig;

  return axios
    .post(MS_URL, formData, requestConfig)
    .then(response => response.data)
  
};
